import './assets/css/main.css'
import Highcharts from 'highcharts'
import 'highcharts/modules/map'
import 'highcharts/modules/drilldown'
import HighchartsVue from "highcharts-vue";
import "highcharts/modules/treemap";
import 'highcharts/modules/annotations';
import 'highcharts/modules/sankey';
import 'highcharts/modules/exporting'
import 'highcharts/modules/offline-exporting'
import 'highcharts/modules/export-data'
import { patternDefs } from './assets/css/patterns.js';
import DownloadFormatter from './components/explorer/options/DownloadFormatter.js'

import { createApp } from 'vue'
import { createGtag } from "vue-gtag";

//import App from './AppPreview.vue'
import App from './App.vue'
import router from './router'

const gtag = createGtag({
  tagId: import.meta.env.VITE_GA_PROPERTY_ID
})

//HighchartsAnnotations(Highcharts);
const app = createApp(App)

app.use(HighchartsVue, { highcharts: Highcharts });
Highcharts.AST.allowedAttributes.push('data-value');
Highcharts.AST.allowedAttributes.push('patternName');
Highcharts.AST.allowedAttributes.push('patternTransform');
Highcharts.setOptions({
	lang: {
		locale: 'en-US',
		numericSymbols: [" k", " M", " B", " T", " P", " E"]
	},
	defs: patternDefs
});

app.use(gtag);
//DownloadFormatter must be loaded before Highcharts
app.use(DownloadFormatter, Highcharts);
//app.use(Highcharts);
//app.use(DownloadFormatter);

router.isReady().then(() => {
  // Example: go to dashboard by default
  if (router.currentRoute.value.path === '/index.html') {
	if(router.currentRoute.value.hash)
		router.push('/' + router.currentRoute.value.hash.substring(1))
	else
	    router.push('/')
  }
})
app.use(router)
app.mount('#app')

// (optional) verify map module loaded
console.log('Map type registered?', !!Highcharts.seriesTypes.map)
